import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    swapButton: {
      position: 'absolute',
      right: -26,
      top: 18,
      zIndex: 1000,
      backgroundColor: theme.palette.background.paper,
      borderRadius: 4,
      padding: 6,

      '& svg': {
        fontSize: 32,
        color: theme.palette.secondary.main,
      },

      '&:hover, &.Mui-disabled': {
        backgroundColor: theme.palette.background.paper,
      },
    },
  }),
)
